import R from "./_common.js";
import w from "../../_styles/common/light.js";
function z(f) {
  const {
    heightTiny: H,
    heightSmall: S,
    heightMedium: T,
    heightLarge: D,
    borderRadius: u,
    fontSizeTiny: $,
    fontSizeSmall: F,
    fontSizeMedium: G,
    fontSizeLarge: W,
    opacityDisabled: E,
    textColor2: e,
    textColor3: I,
    primaryColorHover: r,
    primaryColorPressed: s,
    borderColor: h,
    primaryColor: t,
    baseColor: o,
    infoColor: l,
    infoColorHover: i,
    infoColorPressed: b,
    successColor: x,
    successColorHover: d,
    successColorPressed: P,
    warningColor: c,
    warningColorHover: a,
    warningColorPressed: p,
    errorColor: n,
    errorColorHover: C,
    errorColorPressed: y,
    fontWeight: L,
    buttonColor2: v,
    buttonColor2Hover: m,
    buttonColor2Pressed: g,
    fontWeightStrong: O
  } = f;
  return Object.assign(Object.assign({}, R), {
    heightTiny: H,
    heightSmall: S,
    heightMedium: T,
    heightLarge: D,
    borderRadiusTiny: u,
    borderRadiusSmall: u,
    borderRadiusMedium: u,
    borderRadiusLarge: u,
    fontSizeTiny: $,
    fontSizeSmall: F,
    fontSizeMedium: G,
    fontSizeLarge: W,
    opacityDisabled: E,
    // secondary
    colorOpacitySecondary: "0.16",
    colorOpacitySecondaryHover: "0.22",
    colorOpacitySecondaryPressed: "0.28",
    colorSecondary: v,
    colorSecondaryHover: m,
    colorSecondaryPressed: g,
    // tertiary
    colorTertiary: v,
    colorTertiaryHover: m,
    colorTertiaryPressed: g,
    // quaternary
    colorQuaternary: "#0000",
    colorQuaternaryHover: m,
    colorQuaternaryPressed: g,
    // default type
    color: "#0000",
    colorHover: "#0000",
    colorPressed: "#0000",
    colorFocus: "#0000",
    colorDisabled: "#0000",
    textColor: e,
    textColorTertiary: I,
    textColorHover: r,
    textColorPressed: s,
    textColorFocus: r,
    textColorDisabled: e,
    textColorText: e,
    textColorTextHover: r,
    textColorTextPressed: s,
    textColorTextFocus: r,
    textColorTextDisabled: e,
    textColorGhost: e,
    textColorGhostHover: r,
    textColorGhostPressed: s,
    textColorGhostFocus: r,
    textColorGhostDisabled: e,
    border: `1px solid ${h}`,
    borderHover: `1px solid ${r}`,
    borderPressed: `1px solid ${s}`,
    borderFocus: `1px solid ${r}`,
    borderDisabled: `1px solid ${h}`,
    rippleColor: t,
    // primary
    colorPrimary: t,
    colorHoverPrimary: r,
    colorPressedPrimary: s,
    colorFocusPrimary: r,
    colorDisabledPrimary: t,
    textColorPrimary: o,
    textColorHoverPrimary: o,
    textColorPressedPrimary: o,
    textColorFocusPrimary: o,
    textColorDisabledPrimary: o,
    textColorTextPrimary: t,
    textColorTextHoverPrimary: r,
    textColorTextPressedPrimary: s,
    textColorTextFocusPrimary: r,
    textColorTextDisabledPrimary: e,
    textColorGhostPrimary: t,
    textColorGhostHoverPrimary: r,
    textColorGhostPressedPrimary: s,
    textColorGhostFocusPrimary: r,
    textColorGhostDisabledPrimary: t,
    borderPrimary: `1px solid ${t}`,
    borderHoverPrimary: `1px solid ${r}`,
    borderPressedPrimary: `1px solid ${s}`,
    borderFocusPrimary: `1px solid ${r}`,
    borderDisabledPrimary: `1px solid ${t}`,
    rippleColorPrimary: t,
    // info
    colorInfo: l,
    colorHoverInfo: i,
    colorPressedInfo: b,
    colorFocusInfo: i,
    colorDisabledInfo: l,
    textColorInfo: o,
    textColorHoverInfo: o,
    textColorPressedInfo: o,
    textColorFocusInfo: o,
    textColorDisabledInfo: o,
    textColorTextInfo: l,
    textColorTextHoverInfo: i,
    textColorTextPressedInfo: b,
    textColorTextFocusInfo: i,
    textColorTextDisabledInfo: e,
    textColorGhostInfo: l,
    textColorGhostHoverInfo: i,
    textColorGhostPressedInfo: b,
    textColorGhostFocusInfo: i,
    textColorGhostDisabledInfo: l,
    borderInfo: `1px solid ${l}`,
    borderHoverInfo: `1px solid ${i}`,
    borderPressedInfo: `1px solid ${b}`,
    borderFocusInfo: `1px solid ${i}`,
    borderDisabledInfo: `1px solid ${l}`,
    rippleColorInfo: l,
    // success
    colorSuccess: x,
    colorHoverSuccess: d,
    colorPressedSuccess: P,
    colorFocusSuccess: d,
    colorDisabledSuccess: x,
    textColorSuccess: o,
    textColorHoverSuccess: o,
    textColorPressedSuccess: o,
    textColorFocusSuccess: o,
    textColorDisabledSuccess: o,
    textColorTextSuccess: x,
    textColorTextHoverSuccess: d,
    textColorTextPressedSuccess: P,
    textColorTextFocusSuccess: d,
    textColorTextDisabledSuccess: e,
    textColorGhostSuccess: x,
    textColorGhostHoverSuccess: d,
    textColorGhostPressedSuccess: P,
    textColorGhostFocusSuccess: d,
    textColorGhostDisabledSuccess: x,
    borderSuccess: `1px solid ${x}`,
    borderHoverSuccess: `1px solid ${d}`,
    borderPressedSuccess: `1px solid ${P}`,
    borderFocusSuccess: `1px solid ${d}`,
    borderDisabledSuccess: `1px solid ${x}`,
    rippleColorSuccess: x,
    // warning
    colorWarning: c,
    colorHoverWarning: a,
    colorPressedWarning: p,
    colorFocusWarning: a,
    colorDisabledWarning: c,
    textColorWarning: o,
    textColorHoverWarning: o,
    textColorPressedWarning: o,
    textColorFocusWarning: o,
    textColorDisabledWarning: o,
    textColorTextWarning: c,
    textColorTextHoverWarning: a,
    textColorTextPressedWarning: p,
    textColorTextFocusWarning: a,
    textColorTextDisabledWarning: e,
    textColorGhostWarning: c,
    textColorGhostHoverWarning: a,
    textColorGhostPressedWarning: p,
    textColorGhostFocusWarning: a,
    textColorGhostDisabledWarning: c,
    borderWarning: `1px solid ${c}`,
    borderHoverWarning: `1px solid ${a}`,
    borderPressedWarning: `1px solid ${p}`,
    borderFocusWarning: `1px solid ${a}`,
    borderDisabledWarning: `1px solid ${c}`,
    rippleColorWarning: c,
    // error
    colorError: n,
    colorHoverError: C,
    colorPressedError: y,
    colorFocusError: C,
    colorDisabledError: n,
    textColorError: o,
    textColorHoverError: o,
    textColorPressedError: o,
    textColorFocusError: o,
    textColorDisabledError: o,
    textColorTextError: n,
    textColorTextHoverError: C,
    textColorTextPressedError: y,
    textColorTextFocusError: C,
    textColorTextDisabledError: e,
    textColorGhostError: n,
    textColorGhostHoverError: C,
    textColorGhostPressedError: y,
    textColorGhostFocusError: C,
    textColorGhostDisabledError: n,
    borderError: `1px solid ${n}`,
    borderHoverError: `1px solid ${C}`,
    borderPressedError: `1px solid ${y}`,
    borderFocusError: `1px solid ${C}`,
    borderDisabledError: `1px solid ${n}`,
    rippleColorError: n,
    waveOpacity: "0.6",
    fontWeight: L,
    fontWeightStrong: O
  });
}
const M = {
  name: "Button",
  common: w,
  self: z
}, B = M;
export {
  B as default,
  z as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/button/styles/light.js
// module id = 168
// module chunks = 41